import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: resolve => require(['@/home'], resolve),
    redirect: {
      path: 'login'
    },
    children: [{
        path: 'login',
        name: 'login',
        component: resolve => require(['@/components/login'], resolve),
      },
      {
        path: 'register',
        name: 'register',
        component: resolve => require(['@/components/register'], resolve),
      },
      {
        path: 'binding',
        name: 'binding',
        component: resolve => require(['@/components/binding'], resolve),
      },
      {
        path: 'forget',
        name: 'forget',
        component: resolve => require(['@/components/forget'], resolve),
      },
    ],
  }, ],
})



// WEBPACK FOOTER //
// ./src/router/index.js